export const dictMKB10Module = 'dictMKB10'
